import { mdx } from '@readme/mdx';

export const deserialize = node => {
  const text = mdx(node).trim();

  return { text };
};
